module.exports = {
          srcSet: __webpack_public_path__ + "images/2014-2-cd749f84eaa0b45332a130afa6e8d5a4-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/2014-2-b4fec42a7252ee1bef7aefc24c063262-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/2014-2-cd749f84eaa0b45332a130afa6e8d5a4-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/2014-2-b4fec42a7252ee1bef7aefc24c063262-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/2014-2-cd749f84eaa0b45332a130afa6e8d5a4-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/2014-2-cd749f84eaa0b45332a130afa6e8d5a4-320.jpg"},
          
          width: 320,
          height: 251
        }